export const locale = {
  lang: 'fr',
  data: {
    subscription: {
      header: 'Souscription FARPODQ',
      okButton: 'Ok',
      yesButton: 'Oui',
      noButton: 'Non',
      restartFormDialog: {
        title: 'Réinitialiser formulaire',
        message: "Le formulaire doit être réinitialisé a cause d'une erreur:"
      },
      form: {
        startDate: 'Date de début',
        noPeriod: "Aucun formulaire a remplir",
        period: {
          title: 'Periode'
        },
        society: {
          title: 'Société:'
        },
        premium: {
          title: 'Prime',
          table: {
            premiumBaseHeader: 'Prime de base',
            creditHeader: 'Crédit',
            surplusHeader: 'Assurance excédentaire',
            surpremimumHeader: 'Surprime*',
            tpaHeader: 'TPA',
            totalHeader: 'Total',
            selectedHeader: 'Choix',
            mandatoryBaseAssurance: 'Assurance obligatoire de base',
            surplusText: 'En excédent de',
            premiumBaseHeaderWithSurplus: 'Prime de base avec excédentaire',
            subtotalHeader: 'Subtotal',
            primeHeader: 'Prime',
            surpremimumFooter: 'La surprime est liée à votre historique de dossiers de réclamations.'
          }
        },
        surplus: {
          title: 'Assurance excédentaire'
        },
        summary: {
          title: 'Resume de Paiement'
        },
        registrationPayment: {
          title: 'Paiement'
        },
        confirmationPayment: {
          title: 'Confirmation de paiement'
        },
        validationReclamation: {
          title: 'Réclamations non rapportées'
        },
        payment: {
          title: "Avis de cotisation",
          total: "Total",
          paymentError: "Une erreur est survenue lors du paiement",
          noBillsFound: "Aucune facture de subscription trouvée",
          sumOrMonerisError: "Le montant de la facture est incorrect, ou problème avec Moneris",
          reassuranceMessage: "Votre carte n'a pas été débitée. Veuillez réessayer.",
          nameUnderCard: "Nom sur la carte bancaire",
          transactionError: "Transaction refusée.",
          billError: "Il semble y avoir une erreur concernant la facturation. Veuillez contacter l'Ordre",
          amountToPayBefore: 'La somme de ',
          amountToPayAfter: ' sera imputée au compte de la carte de crédit.',
          byPassMoneris: 'Bypass Moneris',
          confirmCredit: 'Confirmer selection',
          invalidSubscriptionNotice: "L'avis de souscription a été annulée",
          invalidAmount: "La somme est invalide",
          criticalError: "Erreur critique",
          checkPayment: "Payer par chèque",
          unexpectedError: "<br>Une erreur de système critique ne permet pas de prendre en compte <br> certains des renseignements " +
            "que vous avez fournis.<br><br>Veuillez communiquer avec Carole Pigeon à l'adresse <a href=mailto:'tableau@odq.qc.ca'>tableau@odq.qc.ca</a>" +
            "<br> avant de continuer."
        }
      }
    }
  }
}